import React from 'react';
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import { Button } from '@mui/material';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';

const ExportToExcel = ({ apiData, fileName, decimalColumns = [] }) => {
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";

  const exportToCSV = () => {
    // Clonar los datos para no modificar los originales
    const clonedData = apiData.map(row => {
      const newRow = { ...row };
      decimalColumns.forEach(col => {
        if (newRow[col] !== undefined) {
          const parsed = parseFloat(newRow[col]);
          newRow[col] = isNaN(parsed) ? 0 : parsed.toFixed(2);
        }
      });
      return newRow;
    });

    const ws = XLSX.utils.json_to_sheet(clonedData);

    // Autoajustar columnas
    const wscols = Object.keys(clonedData[0]).map((key) => {
      const maxLength = clonedData.reduce((max, row) => {
        const value = row[key] ? row[key].toString() : "";
        return Math.max(max, value.length);
      }, key.length);
      return { wch: maxLength + 2 };
    });
    ws['!cols'] = wscols;

    // Filtros en cabecera
    ws['!autofilter'] = { ref: ws['!ref'] };

    // Formato de celdas decimales
    if (decimalColumns.length > 0) {
      const rangeCells = XLSX.utils.decode_range(ws['!ref']);
      for (let R = rangeCells.s.r + 1; R <= rangeCells.e.r; ++R) {
        for (let C = rangeCells.s.c; C <= rangeCells.e.c; ++C) {
          const cellAddress = XLSX.utils.encode_cell({ r: R, c: C });
          const cell = ws[cellAddress];

          const columnKey = Object.keys(clonedData[0])[C];
          if (cell && decimalColumns.includes(columnKey) && typeof cell.v === 'number') {
            cell.z = '0.00'; 
          }
        }
      }
    }

    const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  };

  return (
    <Button onClick={exportToCSV}>
      <FileDownloadOutlinedIcon /> Exportar
    </Button>
  );
};

export default ExportToExcel;
